const ehNumero = (valor) => typeof valor === "number" && Number.isFinite(valor);

export const filtrosDaAtencao = (filtros) => {
  const resultado = {};
  if (filtros?.zone_id?.length) resultado.zone_id = filtros.zone_id;
  if (filtros?.collection_legacy_id?.length)
    resultado.collection_legacy_id = filtros.collection_legacy_id;
  if (filtros?.category_id?.length) {
    resultado.category_source = filtros.category_source;
    resultado.category_id = filtros.category_id;
  }
  return resultado;
};

export const zonasComAtencao = (atencao) =>
  (atencao?.branches?.[0]?.groups || []).filter(
    (zona) => (zona.pessoa_minuto || 0) > 0 || (zona.minutos_ocupados || 0) > 0
  );

export const zonasDaMedia = (zonas, zonasEscolhidas) =>
  zonasEscolhidas?.length
    ? zonas
    : zonas.filter((zona) => !zona.is_staff_zone && !zona.is_fila_zone);

export const mediaPorZona = (zonas) => {
  const comAtencao = zonas.filter((zona) => (zona.pessoa_minuto || 0) > 0);
  if (!comAtencao.length) return null;
  return (
    comAtencao.reduce((soma, zona) => soma + zona.pessoa_minuto, 0) /
    comAtencao.length
  );
};

export const cartoesDoFluxo = ({ atencao, conversao, fila, filtros }) => {
  const filial = atencao?.branches?.[0];
  const ocupacao = filial?.ocupacao_pct;
  return {
    total_oportunidades: conversao?.totals?.oportunidades ?? null,
    occupied_percent: ehNumero(ocupacao) ? ocupacao / 100 : null,
    max_people: filial?.pico ?? null,
    avg_occupied_time: mediaPorZona(
      zonasDaMedia(zonasComAtencao(atencao), filtros?.zone_id)
    ),
    avg_queue_wait: fila?.espera_media_min ?? null,
  };
};

export const indisponiveisDoFluxo = (cartoes) =>
  ["occupied_percent", "max_people", "avg_occupied_time"].filter(
    (chave) => !ehNumero(cartoes?.[chave])
  );

export const temDadoDeZona = (atencao) => {
  const filial = atencao?.branches?.[0];
  return !filial || filial.pico !== null;
};

export const tabelasDoFluxo = (atencao, filtros) => {
  const zonas = zonasComAtencao(atencao);
  const media = mediaPorZona(zonasDaMedia(zonas, filtros?.zone_id)) ?? 0;
  const linhas = zonas.map((zona) => ({
    id: String(zona.zone_id),
    description: zona.zone_name,
    permanence: zona.pessoa_minuto ?? 0,
    ocupation: zona.ocupacao_pct ?? 0,
    peak: zona.pico ?? null,
  }));
  return {
    above_mean: linhas.filter((linha) => linha.permanence >= media),
    below_mean: linhas.filter((linha) => linha.permanence < media),
  };
};

export const barrasDoFluxo = (atencao) => {
  const zonas = zonasComAtencao(atencao).sort(
    (a, b) => (b.pessoa_minuto || 0) - (a.pessoa_minuto || 0)
  );
  return {
    labels: zonas.map((zona) => zona.zone_name),
    datasets: [
      {
        label: "Tempo de Atenção (min)",
        data: zonas.map((zona) => zona.pessoa_minuto || 0),
        backgroundColor: "rgba(0, 0, 0, 0.7)",
      },
    ],
  };
};

export const serieDoFluxo = (atencao) => {
  const minutos = atencao?.branches?.[0]?.groups || [];
  return {
    historic_time: minutos.map((minuto) => minuto.key),
    historic_amount_of_people: minutos.map(
      (minuto) => minuto.pessoas_medias ?? 0
    ),
  };
};
